import { mdiAlert } from '@mdi/js';
import Icon from '@mdi/react';

type ErrorMessagesProps = {
  className?: string;
  errors: string[];
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

export default function ErrorMessages({ className = '', errors, size = 'xs' }: ErrorMessagesProps) {
  let textSize = '';
  let iconSize = 0;
  if (size === 'xs') {
    iconSize = 0.6;
    textSize = 'text-xs';
  }
  if (size === 'sm') {
    iconSize = 0.8;
    textSize = 'text-sm';
  }
  if (size === 'md') {
    iconSize = 1;
    textSize = 'text-md';
  }
  if (size === 'lg') {
    iconSize = 1.2;
    textSize = 'text-lg';
  }

  return (
    <>
      {errors.length > 0 && (
        <ul className={`flex w-full flex-col items-start gap-1 ${className}`}>
          {errors.map((error, index) => (
            <li key={index} className={`flex items-center gap-1 ${textSize} text-primary sm:justify-center`}>
              <Icon path={mdiAlert} size={iconSize} />
              {error}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
